/**
 * The copyable technical block support asks for, with the session's credentials removed.
 *
 * The session id is not a harmless identifier — it is the bearer token for the finish and result
 * endpoints, and the account it names is live on a production PBX for five minutes. It, the
 * username and the password must not reach the DOM, the console or the clipboard, so the redaction
 * is a deny-list applied at every depth rather than a hand-picked subset of fields.
 */

import type { StatsSample } from './stats'
import type { CallTestResult } from './types'

const SECRET_KEYS = new Set(['sessionId', 'username', 'password'])

export function buildTechnicalDetails(
	result: CallTestResult | null,
	samples: StatsSample[]
): string {
	return JSON.stringify({
		platform: result ? redact(result) : null,
		browserSamples: samples
	}, null, 2)
}

/** Drops every secret-named key at any depth, leaving the rest of the structure intact. */
function redact(value: unknown): unknown {
	if (Array.isArray(value)) return value.map(redact)

	if (typeof value === 'object' && value !== null) {
		return Object.fromEntries(
			Object.entries(value)
				.filter(([key]) => !SECRET_KEYS.has(key))
				.map(([key, nested]) => [key, redact(nested)])
		)
	}

	return value
}
